const localizedPath = (language, path) => (language.DEFAULT ? path : language.PATH + path)
const unlocalizedPath = (language, path) => (language.DEFAULT ? path : path.replace(language.PATH, ''))

module.exports = {localizedPath, unlocalizedPath}

// const cleanPath = e => '/' + e.replace(/^\/|\/$/g, '') // FIXME:
// const normalizePath = e => '/' + e.replace(/^\/|\/$/g, '') + '/' // FIXME:
